<script setup>
import MessengerItem from "@/components/intercom/MessengerItem.vue";
import { useLayout } from "@/composables/useLayout";

import QuickStartButton from "./quickStart/QuickStartButton.vue";

const { noNav, showFrame } = useLayout();
</script>

<template>
  <div v-if="!noNav" class="floating-actions">
    <QuickStartButton v-if="showFrame" />
    <MessengerItem />
  </div>
</template>

<style lang="scss" scoped>
.floating-actions {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 8px;

  :deep(.messenger-menu-group) {
    position: static;
    bottom: auto;
    right: auto;
  }
}
</style>
